import { safeApiRequest } from './apiClient';

const ENDPOINT = '/api/admin/test-veri-temizle';

export const fetchTestVeriTemizleDurum = () =>
  safeApiRequest(`${ENDPOINT}/durum`, { method: 'GET', skipCsrf: true });

/**
 * @param {{ cihazlariSil?: boolean }} payload
 */
export const runTestVeriTemizle = (payload) =>
  safeApiRequest(`${ENDPOINT}/run`, {
    method: 'POST',
    body: payload,
  });
